import imageUrlBuilder from '@sanity/image-url'

const SANITY_PROJECT_ID = import.meta.env.VITE_SANITY_PROJECT_ID!;
const SANITY_DATASET = import.meta.env.VITE_SANITY_DATASET!;


const config = {
  projectId: SANITY_PROJECT_ID, 
  dataset: SANITY_DATASET
}

const builder = imageUrlBuilder(config)

export const urlFor = (source) => {
  try {
    return builder.image(source).url()
  } catch (error) {
    console.error('Error building image URL:', error)
    return null
  }
}